import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../services/authService";

const SignOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    // Logout sonrası sign-in'e yönlendir
    navigate("/authentication/sign-in", { replace: true });
  }, [navigate]);

  return <div>Çıkış yapılıyor...</div>;
};

export default SignOut;
